import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Oklahoma Tier2 Submit": {
    parameters: {
      linkUrls: ["https://applications.deq.ok.gov/TierIIOnline/Login.aspx"],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
          receipt: true,
          submission: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Tier2 Submit",
    consolidated: "Once Per Credential",
    state: "OK",
  },
};
